"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ChoicesList = _interopRequireDefault(require("./ChoicesList"));
var _ChoicesItem = _interopRequireDefault(require("./ChoicesItem"));
function CreateChoiceList({
  list,
  initialItem = null,
  handleOnClick
}) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, initialItem && (initialItem === null || initialItem === void 0 ? void 0 : initialItem.status) !== 'filtered' && /*#__PURE__*/_react.default.createElement(_ChoicesItem.default, {
    item: initialItem,
    handleOnClick: handleOnClick,
    key: initialItem.id,
    disabled: (initialItem === null || initialItem === void 0 ? void 0 : initialItem.status) === 'selected'
  }), /*#__PURE__*/_react.default.createElement(_ChoicesList.default, null, list.map(item => {
    if (item.subcategories.length) return /*#__PURE__*/_react.default.createElement(CreateChoiceList, {
      list: item.subcategories,
      initialItem: item,
      handleOnClick: handleOnClick,
      key: `list-${item.id}`
    });
    return item.status !== 'filtered' ? /*#__PURE__*/_react.default.createElement(_ChoicesItem.default, {
      item: item,
      handleOnClick: handleOnClick,
      key: item.id,
      disabled: item.status === 'selected'
    }) : '';
  })));
}
var _default = exports.default = CreateChoiceList;